<template>
      <v-card class="mx-auto" shaped elevation="7">
            <v-card-title>
                  Registro Opción
                  <v-spacer></v-spacer>
                  <v-btn rounded dark color="primary" @click="clear(true)">Nuevo</v-btn>
                  <ModalOpcionComponent :open="obModal.open" :listGeneral="listGeneral" :parametros="parametros" :obModal="obModal" />
            </v-card-title>
            <v-container fluid grid-list-sm>
                  <v-row dense>
                        <v-col cols="12" sm="4">
                              <v-autocomplete label="Módulo *" color="textbox" :items="listGeneral.listModulo"
                                    v-model='obSearch.idModulo' outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                              <v-autocomplete label="Estado *" color="textbox" :items="listGeneral.listEstado"
                                    item-text="nombre_estado" item-value="id_estado" v-model='obSearch.idEstado'
                                    outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                              <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                          <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                                :disabled="disabled">
                                                <v-icon dark>search</v-icon>
                                          </v-btn>
                                    </template>
                                    <span>Buscar</span>
                              </v-tooltip>
                        </v-col>
                  </v-row>

                  <v-row dense>
                        <v-col cols="12" sm="6" />
                        <v-col cols="12" sm="6">
                              <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                                    prepend-inner-icon="search" />
                        </v-col>
                  </v-row>

                  <v-row dense>
                        <v-col cols="12">
                              <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera"
                                    :items="listGeneral.detalle" class="elevation-3">

                                    <template v-slot:item.name="{ item }">
                                          <v-btn class="ma-2" text icon color="primary" @click="editItem(item)">
                                                <v-icon small>edit</v-icon>
                                          </v-btn>
                                    </template>

                                    <template v-slot:no-results>
                                          Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                                    </template>
                              </v-data-table>
                        </v-col>
                  </v-row>
            </v-container>
      </v-card>
</template>

<script>
      export default {
            name: 'OpcionView',
            components:{
                  ModalOpcionComponent: () => import('@/components/seguridad/ModalOpcionComponent.vue')
            },
            data: () => ({
                  obSearch: {
                        search: '',
                        idModulo: null,
                        idEstado: null
                  },
                  obModal: {
                        open: false,
                        titulo: ''
                  },
                  listGeneral: {},
                  parametros: {},
                  disabled:false
            }),
            created() {
                  var error = 'E';
                  this.disabled = true;
                  axios.post(`${BASE_URI}administrador/opcion/cargaGeneral`)
                        .then((r) => {
                              if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                              if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                    this.$set(this, 'listGeneral', r.data.data.listas);
                                    this.$set(this, 'parametros', r.data.data.parametros);
                                    this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                                    this.obSearch.idModulo = _.get(this.listGeneral,['listModulo','1','value'],null);
                                    this.disabled = false;
                                    this.onListar('L');
                        })
                        .catch((e) => {
                              this.disabled = false;
                              mensajesAlerta(e, error);
                        })
            },
            methods: {
                  clear(band) {
                        this.obModal = {
                              open: band,
                              titulo: 'Nueva Opción',
                              idEstado: _.toString(this.parametros.id_estado_default)
                        }
                  },
                  onListar(ev){
                        if(!_.isUndefined(ev)){
                              var error = 'E';
                              this.disabled = true;
                              axios.post(`${BASE_URI}administrador/opcion/listar`,_.merge({opcion:'LISTAR'},_.omit(this.obSearch,'search')))
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                                this.listGeneral.detalle = r.data.data;
                                                this.disabled = false;
                                    })
                                    .catch((e) => {
                                          mensajesAlerta(e, error);
                                          this.disabled = false;
                                    });
                        }
                  },
                  editItem(v){
                        this.obModal = _.merge({},this.obModal,v,{titulo:'Editar Opción',open:true});
                  },
                  submit(){
                        var error = 'E';
                        var keys = ['open','titulo','modulo','estado'];
                        var o = _.merge({opcion:_.size(this.obModal.idOpcion) == 0 ? 'I' : 'U'},_.omit(this.obModal,keys));

                        axios.post(`${BASE_URI}administrador/opcion/insertOrUpdate`,o)
                              .then((r)=>{
                                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                          mensajeAlertaTiempo(r.data.mensaje,'S');
                                          this.disabled = false;
                                          this.clear(false);
                                          this.onListar('L');
                              })
                              .catch((e) => {
                                    mensajesAlerta(e, error);
                                    this.disabled = false;
                              });
                  }
            },
            provide(){
                  return{
                        close:this.clear,
                        submit:this.submit
                  }
            }
      }
</script>